module.exports = __webpack_public_path__ + "img/WTMS_sword1.91fb0fef.png";